import { render, staticRenderFns } from "./EditedOk.vue?vue&type=template&id=610500dc&scoped=true&lang=pug"
import script from "./EditedOk.vue?vue&type=script&lang=js"
export * from "./EditedOk.vue?vue&type=script&lang=js"
import style0 from "./EditedOk.vue?vue&type=style&index=0&id=610500dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "610500dc",
  null
  
)

export default component.exports